import script from "./EventSingle.vue?vue&type=script&setup=true&lang=js"
export * from "./EventSingle.vue?vue&type=script&setup=true&lang=js"

import "./EventSingle.vue?vue&type=style&index=0&id=e1c8842a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1c8842a"]])

export default __exports__